import { Button } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import { Person } from '@mui/icons-material';
import { Col, Row } from "antd";
import { DeleteModal } from "components/Dialog";
import { has } from "lodash";
import React, { useEffect, useState } from "react";
import { useShareNotification } from "utils/methods/firebaseShareAssignment";
import EditSentenceStarter from "./editSentenceStarter";
import SentryWrap from 'components/Sentry';

export default function SentenceStarter() {
  const [loading, setLoading] = useState(false);
  const [deleteToggle, setDeleteToggle] = useState(false);
  const [sentenceData, setSentenceData] = useState({});
  const { deleteSentenceData, listenToSentenceData } = useShareNotification();
  const [videoModalInfo, setVideoModalInfo] = React.useState({
    open: false,
    item: null,
  });
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const id = `admin_sentence-${import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev"}`

  useEffect(() => {
    const unsubscribe = listenToSentenceData(id, (data) => {
      setSentenceData(data?.[id]);
    });
    return () => unsubscribe();
  }, []);


  const onAdd = () => {
    setVideoModalInfo({ open: true, item: {} });
  };
  const handleEdit = (item) => {
    setVideoModalInfo({ open: true, item: item });
  };
  const onDeleteItem = async () => {
    if (has(sentenceData, "id")) {
      setLoading(true);
      await deleteSentenceData(sentenceData?.id);
      setLoading(false);
    }
    setDeleteToggle(false);
  };


  return (
    <SentryWrap>
      <EditSentenceStarter
        editResourseModal={videoModalInfo.open}
        item={sentenceData}
        onCloseModal={() => setVideoModalInfo({ open: false, item: null })}
        selectedLanguage={selectedLanguage}
        id={id}
      />
      <DeleteModal
        deleteToggle={deleteToggle}
        setDeleteToggle={setDeleteToggle}
        onDelete={onDeleteItem}
        message={`Are you sure you want to delete ?`}
        loading={loading}
      />
      <Button
        variant="contained"
        color="primary"
        style={{
          marginTop: 24,
          transition: "background-color 0.3s ease",
          cursor: sentenceData?.id ? "not-allowed" : "pointer",
        }}
        onClick={onAdd}
        disabled={sentenceData?.id}
        onMouseEnter={(e) =>
          !sentenceData?.id &&
          (e.currentTarget.style.backgroundColor = "#388e3c")
        }
        onMouseLeave={(e) =>
          !sentenceData?.id && (e.currentTarget.style.backgroundColor = "")
        }
      >
        <Add /> Add Sentence Starter
      </Button>
      <Row className="learnContentUpr" gutter={[25, 0]}>
        <Col xs={24} sm={24} md={24}>
          <div className="learnContent">
            <div className="myCategorys">
              {sentenceData?.id && (
                <div className="myCategoryList OneWayVideoCover">
                  <div className=" card-resource ShowDetailBnr">
                    <div className="btnsGrpMain">
                      <div
                        className="btnsGrpTxt"
                        style={{ justifyContent: "center" }}
                      >
                        <Button
                          className="btnsTxtYellow"
                          onClick={() => handleEdit(sentenceData)}
                          style={{
                            transition: "transform 0.2s ease-in-out",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.1)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        >
                          <Edit style={{ fontSize: 20, marginRight: 3 }} />
                          Edit
                        </Button>
                        <Button
                          style={{
                            marginLeft: 10,
                            transition: "transform 0.2s ease-in-out",
                            cursor: "pointer",
                          }}
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            setDeleteToggle(true);
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.1)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        >
                          <Delete style={{ fontSize: 20, marginRight: 3 }} />
                          Delete
                        </Button>
                      </div>
                    </div>
                    <img src={sentenceData?.url} className="object-fit-contain" alt="" />
                  </div>
                  <div style={{ height: "auto" }} className="SentenceBtnTxt">
                    <div className="sentence-starter-txt">Sentence Starter</div>
                    <div className="btm1Category">
                      <div className="persionIconImg">
                        <Person className="iconClrChange" />
                        <span>{"ONE WAY EDUCATION"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </SentryWrap>
  );
}
